/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDetailView = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M7 18H5v-2h2zm0-4H5v-2h2zm0-4H5V8h2zm11 8h-6v-2h6zm0-4h-6v-2h6zm0-4h-6V8h6z" />
        <path d="M22 22H2V2h20zM4 20h4V6H4zm6 0h10V6H10z" />
      </g>
    </g>
  </Icon>
);
export { SvgDetailView as DetailView };
